<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        origin="top center"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Edycja kartonów
                </h1>
            </v-card-title>

            <div class="mx-4 my-1">
                <v-row>
                    <v-col cols="12">
                        <v-slider
                            v-model="parcelsCount"
                            label="Ilość kartonów"
                            thumb-label
                            ticks
                            always-dirty
                            :min="1"
                            :max="parcelMaxCount"
                            :step="1"
                            :disabled="parcelsLoading"
                            @input="setParcels"
                        />
                    </v-col>
                </v-row>
            </div>

            <v-card-text style="height: 250px">
                <v-container class="pa-0">
                    <v-row>
                        <v-col
                            v-for="(item, index) in parcelsCount"
                            :key="index"
                            cols="12"
                            sm="6"
                            md="4"
                        >
                            <v-text-field
                                v-model="parcels[index].weight"
                                :label="`Karton ${index + 1}`"
                                :disabled="parcelsLoading"
                                :error-messages="localParcelsErrors(parcels[index].weight)"
                                suffix="kg"
                                required
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="parcelsLoading"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :loading="parcelsLoading"
                    @click="updateParcels"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'
import { appConfig } from '@/config'
import weightFormatter from '@/mixins/weightFormatter'

export default {
    name: 'ParcelsDialog',
    mixins:[
        weightFormatter
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        orderId: {
            type: Number,
            default: null
        },
        deliveryData: {
            type: Object,
            default: () => {}
        },
        orderType: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            parcels: [],
            parcelsCount: null,
            parcelsLoading: false
        }
    },
    validations() {
        return {
            parcels: {
                $each: {
                    weight: {}
                }
            }
        }
    },
    computed: {
        parcelMaxCount() {
            return appConfig.orders.parcelMaxCount
        },
        parcelMinWeight() {
            return appConfig.orders.parcelMinWeight
        },
        parcelMaxWeight() {
            return appConfig.orders.parcelMaxWeight
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.parcels = JSON.parse(JSON.stringify(this.deliveryData.parcels))

                // Formatting weight with comma for input field
                this.parcels.forEach(p => { p.weight = this.formatWeight(p.weight, false) })

                this.parcelsCount = this.parcels.length
            } else {
                setTimeout(() => {
                    this.$v.$reset()
                    this.parcels = []
                    this.parcelsCount = null
                }, 500)
            }
        }
    },
    methods: {
        setParcels() {
            this.parcels = []
            this.$v.$reset()

            for (let index = 0; index < this.parcelsCount; index++) {
                this.parcels.push({
                    weight: null
                })
            }
        },
        updateParcels() {
            const isValid = !this.parcels.filter((p) => !!this.localParcelsErrors(p.weight).length ).length

            if (!isValid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.parcelsLoading = true

            const actionName = this.orderType === 'ecommerce' ? 'orders/updateDelivery' : 'orders/updateCooperantDelivery'

            // Formatting weight with point for api
            const parcelsForAPI = JSON.parse(JSON.stringify(this.parcels))

            parcelsForAPI.forEach(p => { p.weight = this.unformatWeight(p.weight) })

            this.$store.dispatch(actionName, {
                id: this.deliveryData.id,
                payload: {
                    parcels: parcelsForAPI
                }
            })
                .then(() => {
                    const actionName = this.orderType === 'ecommerce' ? 'orders/getOrder' : 'orders/getCooperantOrder'

                    this.$store.dispatch(actionName, this.orderId)
                        .then(response => {
                            this.onSave(response.data)
                        })
                        .catch(error => {
                            errorHandler(error)
                        })
                        .finally(() => {
                            this.parcelsLoading = false
                            this.onClose()
                        })
                })
                .catch(error => {
                    this.parcelsLoading = false
                    this.onClose()
                    errorHandler(error)
                })
        },
        onSave(payload) {
            this.$emit('on-save', payload)
        },
        onClose() {
            this.$emit('on-close')
        },
        //Walidacje
        localParcelsErrors(weight) {
            const errors = []
            
            const value = this.unformatWeight(weight)
            
            if (weight === '' || weight === null) {
                errors.push('Pole jest wymagane.')
            }
            
            if (isNaN(value) || (weight && weight.match(/[.]+/) !== null)) {
                errors.push('Niepoprawny format.')
            }

            if (value < this.parcelMinWeight || value > this.parcelMaxWeight) {
                errors.push(`Waga powinna zawierać się w przedziale ${this.formatWeight(this.parcelMinWeight, false)} - ${this.formatWeight(this.parcelMaxWeight, false)} kg.`)
            }

            return errors
        }
    }
}
</script>

